<template>
  <div class="modal-mask-home background-melody">
        <div class="instructions">
          <video id="videogalleryInstructions" pause>
        <source :src="require('@/assets/videos/' + $t('games.video.melody') + '.mp4')" type="video/mp4">
          </video>
        </div>
        <div class="closeInstructions tamanhoicon" @click="$emit('closeModal')">
          <img :src="require('@/assets/buttons/newbuttons/melody/close.svg')" />
        </div>
        <span @click="videoPlay()" class="tamanhoicon posicon">
                <img v-if="videopause" :src="require('@/assets/buttons/newbuttons/melody/play.svg')" />
        </span>
</div>

</template>

<script>

export default {

  name: "Instructions",
  emits: ['closeModal'],
  components: {
 },
   data() {
        return {
            videopause: true,
        };
    },
  created() {
    //document.getElementById('videogalleryInstructions').addEventListener('ended',this.videoPlay());
  },
  props: {},
  methods: {
      videoPlay(){
        var video=document.getElementById("videogalleryInstructions");
        
        this.videopause=!this.videopause;
        if (this.videopause){
            video.pause();
            
        } else {
            video.play();
        }
        console.log(this.videopause);
    },
  },
   mounted() {
   }
}

</script>

<style>
.instructions{
    position: absolute;
    display: flex;
    justify-content: center;
    align-content: center;
    width: 100%;
    height: 100%;
}
.posicon{
    position: absolute;
    bottom: 45%;
    left: 48%;
}
#videogalleryInstructions{
    width: 75%;
    z-index: -10;
    border-radius: 20px;
    top: 0;
}
.closeInstructions{
    position: absolute;
    right: 7%;
    top: 7%;
}

@media only screen and (max-width: 480px) {

  .button-list-style-melody > div {
     width:2rem;
  }
}
@media only screen and (min-width: 480px) and (max-width: 550px) {

  .button-list-style-melody > div{
    width:2.2rem;
  }
}
@media only screen and (min-width: 550px) and (max-width: 630px){

  .button-list-style-melody > div{
    width:2.4rem;
  }
}
@media only screen and (min-width: 630px) and (max-width: 718px){

  .button-list-style-melody > div{
    width:2.6rem;
  }
}
@media only screen and (min-width: 718px) and (max-width: 806px) {

  .button-list-style-melody > div{
    width:2.8rem;
  }
}
@media only screen and (min-width: 806px) and (max-width: 1024px) {

  .button-list-style-melody > div{
    width:3rem;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1200px) {

  .button-list-style-melody > div{
    width:3.2rem;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1366px) {

  .button-list-style-melody > div{
    width:3.4rem;
  }
}
@media only screen and (min-width: 1366px) and (max-width: 1540px){

  .button-list-style-melody > div{
    width:4rem;
  }
  #star-melody{
    width: 2.5rem;
  }
  #smallcloud-melody {
    width: 4rem;
  }
  #bigcloud-melody{
    width: 10rem;
  }
  #downStarFill-melody{
    width: 4rem;
  }
  #mediumcloud-melody{
    width: 6rem;
  }
  #upStarStroke-melody{
    width: 3rem;
  }
}
@media only screen and (min-width: 1540px) and (max-width: 1680px){

  .button-list-style-melody > div{
    width:4.4rem;
  }
}
@media only screen and (min-width: 1680px) and (max-width:2350px){

  .button-list-style-melody > div{
    width:4.8rem;
  }
}
@media only screen and (min-width: 2350px) {

  .button-list-style-melody > div{
    width:4.8rem;
  }
}

</style>